import React from "react"

const NewNotificationIcon = () => {
  return (
    <div className="new-notification-icon"></div>
  )
}

export default NewNotificationIcon
